var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"tm-move",rawName:"v-tm-move",value:(_vm.moveObj),expression:"moveObj"}],staticClass:"tm-overlay-resize",class:{
    l: _vm.$props.fromLeft,
    r: _vm.$props.fromRight,
    n: _vm.isNarrow,
    v: _vm.$props.visible || _vm.isActive,
    a: _vm.isActive,
  },style:(_vm.styleObj),on:{"mouseenter":_vm.$_onHoverOverlay,"mouseleave":_vm.$_onHoverOverlay}},[_c('i',{staticClass:"-backlight"}),_vm._v(" "),_c('i',{staticClass:"-mark"})])}
var staticRenderFns = []

export { render, staticRenderFns }